import React, { Component } from 'react';
import { connect } from 'react-redux';
import btoa from 'btoa';
import _ from 'lodash';

import { SignupLiteModal } from 'shared-components/flow-signup/signup-lite-modal';
import { EmailVerifyModal } from 'shared-components/flow-signup/email-verify-modal';
import { AvatarModal } from 'shared-components/flow-signup/avatar-modal';
import ModalManager from '../elements-modal/modal-manager';
import { PermissionModal } from '../flow-projects/permission-modal';
import { JoinBlockerModal } from '../flow-projects/project-join-blocker-modal';
import { ErrorModal } from '../elements-modal/error-modal';
import { updateProfile, createProfile, initAuth, fetchProfile } from '../app-main/actions/auth';
import { fetchProject, fetchAttachments, createAttachments, joinBoard } from '../app-main/actions/projects';
import { checkGrants, createSession } from '../app-main/actions/session';
import { FormattedMessage } from 'react-intl';

class ModalContainer extends Component {
  constructor (props) {
    super(props);

    this.updateProfileAction = this.updateProfileAction.bind(this);
    this.updateProfileActionCb = this.updateProfileActionCb.bind(this);
    this.checkGrantsAction = this.checkGrantsAction.bind(this);
    this.signupAction = this.signupAction.bind(this);
    this.signupActionCb = this.signupActionCb.bind(this);
    this.signinAction = this.signinAction.bind(this);
    this.signinActionCb = this.signinActionCb.bind(this);
    this.joinAction = this.joinAction.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.emailVerifyCb = this.emailVerifyCb.bind(this);
    this.dismissLogin = this.dismissLogin.bind(this);
  }

  updateProfileAction (profileObj, callback) {
    const { dispatch } = this.props;
    dispatch(updateProfile(profileObj))
      .then(res => {
        callback(res);
      })
      .catch(err => {
        callback(err);
      });
  }

  updateProfileActionCb () {
    const isEmailVerified = _.get(this.props, ['profile', 'data', 'email_verified'], false);
    if (isEmailVerified) {
      return this.props.whichModalCb();
    }
    return this.props.toggleModal('emailVerifyModal', this.props.whichModalCb);
  }

  checkGrantsAction (username, profileBody, callback) {
    const { dispatch } = this.props;
    dispatch(checkGrants(username))
      .then(res => {
        callback(res, profileBody);
      })
      .catch(err => {
        callback(err, profileBody);
      });
  }

  joinAction () {
    const {
      dispatch,
      toggleModal,
      joinAnalytics,
      profile: {
        SSOid,
        data: {
          email_verified
        }
      },
      auth: {
        accessToken
      },
      params: {
        externalID = ''
      }, 
      inviteId
    } = this.props;

    const project = _.get(this.props, ['entities', 'projects', externalID]);
    const boardID = (project || {})._id;

    // record join click analytic
    analyticsIntegrations.boardJoinClicked(boardID);

    // if signed in, join them up
    if (SSOid) {
      return dispatch(joinBoard(boardID, SSOid, accessToken, externalID, inviteId))
        .then(() => {
          joinAnalytics(project, SSOid);
          return toggleModal('');
        });
    }

    // if not signed in, open signup modal
    return toggleModal('signUpLiteModal', () => {
      return toggleModal('avatarModal', () => {
        if (!email_verified) {
          return toggleModal('emailVerifyModal', () => {
            return toggleModal('');
          });
        }
        return toggleModal('');
      });
    });
  }

  signupAction (profileObj, callback) {
    const { dispatch, joinAnalytics, params: { externalID = '' } } = this.props;
    const inviteId = _.get(this.props, ['location', 'query', 'project_invite_id'], '');
    const query = inviteId ? `?project_invite_id=${inviteId}` : '';
    // Must create profile before fetching new project data
    dispatch(createProfile(profileObj, query))
      .then(res => {
        const { access_token: accessToken, SSOid } = res;
        const project = _.get(this.props, ['entities', 'projects', externalID], {});

        analyticsIntegrations.trackEvent('account created', {
          label: 'boards',
          action: 'join_board',
          page_type: 'boards',
          user_id: SSOid,
          activity: project.activity,
          location: project.location,
          board_id: project._id,
          email_opt_out: profileObj.unsubscribe,
          // SignupLiteModal supports only email sign-up
          method: 'email'
        });

        // Run initAuth in parallel
        dispatch(initAuth(btoa(accessToken)));
        return res;
      })
      .then((profileRes) => {
        // if the user is only copying the board and does not have the invite code
        // we want to create a profile but not add as collaborator for this board
        if (this.props.signInUserAction === 'copy board' && !PSSessions.Cookies('project_invite_id')) {
          return profileRes;
        }
        // here we will need to split the path
        // & create collaborator if there isn't a query
        // in case of query, collaborator is created by
        // backend
        const project = _.get(this.props, ['entities', 'projects', externalID]);
        const boardID = project._id;
        const access = btoa(profileRes.access_token);
        const { SSOid } = profileRes;
        return dispatch(createAttachments(boardID, SSOid, access, 'COLLABORATOR', this.props.inviteId))
          .then(() => {
            joinAnalytics(project, SSOid);
            return profileRes;
          });
      })
      .then((profileRes) => {
        return dispatch(fetchProject(externalID)).then(() => { return profileRes; });
      })
      .then((profileRes) => {
        return callback(profileRes, profileObj);
      })
      .catch(err => {
        callback(err, profileObj);
      });
  }

  signupActionCb () {
    if (this.props.whichModalCb) {
      this.props.whichModalCb(true);
    }
  }

  signinAction (username, password, callback, profileDetails) {
    const { dispatch, params, projects = {} } = this.props;
    dispatch(createSession(username, password))
      .then(res => {
        const { access_token: accessToken } = res;
        // Run initAuth in parrallel
        dispatch(initAuth(btoa(accessToken)));
        return res;
      })
      .then(res => {
        const listingExternalID = params.externalID;
        return dispatch(fetchAttachments(projects[listingExternalID]._id, btoa(res.access_token)))
          .then(() => {
            return res;
          });
      })
      .then(res => {
        if (profileDetails) {
          return dispatch(updateProfile(profileDetails))
            .then(newProfileDetails => {
              return Object.assign({}, res, newProfileDetails.profile);
            });
        }
        return res;
      })
      .then(res => {
        return callback(res);
      })
      .catch(err => {
        callback(err);
      });
  }

  signinActionCb () {
    if (this.props.whichModalCb) {
      this.props.whichModalCb();
    }
  }

  closeModal () {
    this.props.toggleModal('', null);
  }

  emailVerifyCb () {
    if (this.props.whichModalCb) {
      this.props.whichModalCb();
    }
  }

  dismissLogin () {
    this.props.toggleModal('', null);
    this.props.userDismissedLogin();
  }

  render () {
    const {
      project: {
        _id: boardId,
        name: boardName,
        created_by_profile: {
          avatar_id: ownerAvatarId,
          first_name: ownerFirstName
        } = {}
      },
      userLoggedOutInvited
    } = this.props;

    return (
      <ModalManager {...this.props}>
        <JoinBlockerModal
          ref="joinBlockerModal"
          onJoinClick={this.joinAction}
          onDismissClick={this.dismissLogin}
          boardOwnerName={ownerFirstName}
          boardName={boardName}
          boardOwnerAvatarId={ownerAvatarId}
          boardId={boardId}
        />
        <SignupLiteModal
          ref="signUpLiteModal"
          checkGrantsAction={this.checkGrantsAction}
          signupAction={this.signupAction}
          signupActionCb={this.signupActionCb}
          signinAction={this.signinAction}
          signinActionCb={this.signinActionCb}
          closeModal={this.closeModal}
          useSearchQuery={true}
          header={
            <h3>
              {
                userLoggedOutInvited ? 
                <FormattedMessage id="web_2.project_signup_lite_modal.sign_up_message" defaultMessage="Sign up to vote, comment, or duplicate this board." />
                :
                 <FormattedMessage id="web_2.project_signup_lite_modal.duplicate_message" defaultMessage="Sign up to duplicate this board." />
              }
            </h3>
          }
        />
        <EmailVerifyModal
          ref="emailVerifyModal"
          emailVerifyCb={this.emailVerifyCb}
          onClose={this.emailVerifyCb}
        />
        <PermissionModal ref="permissionModal"/>
        <ErrorModal ref="errorModal"/>
        <AvatarModal
          ref="avatarModal"
          updateProfile={this.updateProfileAction}
          updateProfileCb={this.updateProfileActionCb}
          closeModal={this.closeModal}
          skipAction={this.updateProfileActionCb}
          onClose={this.updateProfileActionCb}
        />
      </ModalManager>
    );
  }
}

ModalContainer.propTypes = {
};

function mapStateToProps (state) {
  const { auth, profile, entities } = state;
  const { accessToken } = auth;
  const { SSOid } = profile;

  return {
    auth,
    profile,
    SSOid,
    accessToken,
    entities
  };
}

export default connect(mapStateToProps)(ModalContainer);
